import { KEYCLOAK_HOST } from './environment'
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import Keycloak from 'keycloak-js'
import { MockKeycloak } from '../../playwright/support/keycloak-mock'

export const keycloak = window?.__E2E__
  ? new MockKeycloak()
  : new Keycloak({
      url: KEYCLOAK_HOST,
      realm: 'TomraConnectUsers',
      clientId: 'voucher-admin-ui'
    })

export const loggedInUserHasRole = (role: string) => {
  if (keycloak.tokenParsed) {
    const { full_resource_access } = keycloak.tokenParsed as { full_resource_access: string[] }
    return full_resource_access.includes(role)
  }

  return false
}
